import { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import {
  IonList,
  IonItem,
  IonLabel,
  IonHeader,
  IonToolbar,
  IonContent,
  IonTitle,
  IonModal,
  IonButtons,
  IonButton,
  isPlatform,
  IonFooter,
  IonSpinner,
} from "@ionic/react";

const isMobile = isPlatform("android") || isPlatform("ios");

// store
import { usePaymentsStore } from "../../store/payments";

// Styles

import modalStyles from "../../theme/modal.module.css";
import inputStyles from "../../theme/input.module.css";

const PaymentDetails = ({
  onWillDismiss,
  isOpen,
  selectedPayment,
  onRefundFunds,
}: {
  isOpen: boolean;
  onWillDismiss: () => void;
  selectedPayment: any;
  onRefundFunds: (payment: any, amount: number) => void;
}) => {
  const { getPayment } = usePaymentsStore();
  const payment = getPayment(selectedPayment?.id);
  const [amount, setAmount] = useState("");
  const [loading, setLoading] = useState(false);

  const onRefund = async () => {
    if (loading) return;
    //convert amount back to cents before sending
    const convertedAmount = Math.round(Math.max(0, Number(amount)) * 100);
    setLoading(true);
    try {
      await onRefundFunds(payment, convertedAmount);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (payment?.amount) {
      setAmount((payment.amountRaw / 100).toFixed(2));
    }
  }, [payment]);

  return payment ? (
    <>
      <IonModal isOpen={isOpen} onWillDismiss={onWillDismiss}>
        <IonHeader>
          <IonToolbar>
            <IonTitle>
              <FormattedMessage id={`leads.payments.refundPayment`} />
            </IonTitle>
            <IonButtons slot="end">
              <IonButton onClick={() => onWillDismiss()}>
                <FormattedMessage id="common.close" />
              </IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          <div
            className={modalStyles.body}
            style={{ padding: isMobile ? "1rem 1.25em" : "1rem" }}
          >
            {payment?.refunds && payment?.refunds.length > 0 && (
              <IonList>
                <IonItem>
                  <IonLabel>
                    <div className="fs-2 color-step-750 fw-bold">
                      <FormattedMessage id="leads.payments.refunds" />
                    </div>
                  </IonLabel>
                </IonItem>
                {payment?.refunds.map((refund: any, index: number) => (
                  <IonItem key={index}>
                    <IonLabel>
                      <div className="fs-2 color-step-750">
                        {refund.date} - {refund.status}
                      </div>
                    </IonLabel>
                    <div slot="end" className="fs-2 color-step-950">
                      {refund.amount}
                    </div>
                  </IonItem>
                ))}
              </IonList>
            )}

            <IonList>
              <IonItem lines="none">
                <div slot="start" className="fs-2 color-step-950">
                  <div className="fs-2 color-step-750 fw-bold">
                    <FormattedMessage id={`leads.payments.refundAmount`} /> (
                    {payment.currency})
                  </div>
                </div>
                <IonLabel>
                  <input
                    id="amount"
                    name="amount"
                    type="number"
                    max={payment.amountRaw / 100}
                    className={inputStyles.input}
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                    autoComplete="off"
                    disabled={loading}
                  />
                </IonLabel>
              </IonItem>
            </IonList>
          </div>
        </IonContent>
        <IonFooter>
          <IonFooter>
            <IonToolbar style={{ paddingLeft: 0, paddingRight: 0 }}>
              <div
                className={modalStyles.footer}
                style={{ borderTop: "0px", padding: "0.5rem 1em" }}
              >
                <button
                  className="btn btn-visito-light w-100"
                  onClick={() => onWillDismiss()}
                  disabled={loading}
                >
                  <FormattedMessage id="common.cancel" />
                </button>
                <button
                  className="btn btn-visito-primary w-100"
                  onClick={() => onRefund()}
                  disabled={loading}
                >
                  {loading ? (
                    <IonSpinner name="crescent" />
                  ) : (
                    <FormattedMessage id="leads.payments.refundPayment" />
                  )}
                </button>
              </div>
            </IonToolbar>
          </IonFooter>
        </IonFooter>
      </IonModal>
    </>
  ) : null;
};
export default PaymentDetails;
